import React from 'react';
import { Result, Button, Space, Alert, theme } from 'antd';
import { ToolOutlined, ReloadOutlined, HomeOutlined, MailOutlined } from '@ant-design/icons';
import { Link } from 'react-router'; // projende Link buradan geliyordu
import { useLanguage } from 'src/providers/LanguageProvider';

const SupportPage: React.FC = () => {
  const { token } = theme.useToken();
  const { t } = useLanguage?.() ?? { t: (_k: string, f: string) => f };

  const handleReload = () => window.location.reload();

  return (
    <Result
          icon={<ToolOutlined style={{ fontSize: 64, color: token.colorPrimary }} />}
          title={t('SUPPORT_UNDER_MAINTENANCE', 'Destek sayfası bakımda')}
          subTitle={t(
            'SUPPORT_UNDER_MAINTENANCE_DESC',
            'Şu anda bazı düzenlemeler yapıyoruz. Bu arada bize e-posta gönderebilir veya ana sayfaya dönebilirsiniz.'
          )}
          extra={
            <Space wrap>
              <Button icon={<ReloadOutlined />} onClick={handleReload}>
                {t('BTN_TRY_AGAIN', 'Tekrar Dene')}
              </Button>
              <Link to="/">
                <Button type="primary" icon={<HomeOutlined />}>
                  {t('BTN_GO_HOME', 'Ana Sayfaya Dön')}
                </Button>
              </Link>
              <Button icon={<MailOutlined />} href="mailto:support@example.com">
                {t('BTN_CONTACT_SUPPORT', 'Destek ile İletişim')}
              </Button>
            </Space>
          }
        />
  );
};

export default SupportPage;
